import { useCallback } from "react";

import { useLocalStorage } from "usehooks-ts";

import { useUser } from "@components/user-context";

import { type SavedSearchTarget } from "./types";

export const useRecentSavedSearches = (target: SavedSearchTarget) => {
  const { user } = useUser();

  const [recentSavedSearchIds, setRecentSavedSearchIds] = useLocalStorage<
    string[]
  >(`nb-recent-saved-searches-${target}-${user.displayUserId}`, []);

  const addSavedSearchIdToHistory = useCallback(
    (id: string) => {
      if (recentSavedSearchIds.includes(id)) {
        setRecentSavedSearchIds(
          [id, ...recentSavedSearchIds.filter((e) => e !== id)].slice(0, 3),
        );
      } else {
        setRecentSavedSearchIds([id, ...recentSavedSearchIds].slice(0, 3));
      }
    },
    [recentSavedSearchIds, setRecentSavedSearchIds],
  );

  return { addSavedSearchIdToHistory, recentSavedSearchIds };
};
